"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var cuid = require("cuid");
var moment = require("moment");
var React = require("react");
var react_redux_1 = require("react-redux");
var env_1 = require("../../helpers/env");
var csrf = require("../../pages/csrfUtils");
var index_1 = require("../profile/index");
var _1 = require("./");
// tslint:disable-next-line:no-var-requires
var styles = require('./comment.css');
exports.mapStateToProps = function (state) {
    return {
        loginUrl: state.loginUrl,
        comments: state.comments,
        user: state.user,
        scene: {
            sceneHandle: state.scene.sceneId,
            handle: state.scene.accountId,
        },
    };
};
exports.mapDispatchToProps = function (dispatch) {
    return {
        newComment: function (comment) {
            if (!comment.uid) {
                comment.uid = cuid();
            }
            dispatch(_1.addComment(comment));
            fetch('/comment', {
                method: 'POST',
                credentials: 'same-origin',
                body: JSON.stringify(comment),
                headers: csrf.withCSRFToken({
                    'Content-Type': 'application/json',
                }),
            })
                .then(function (res) {
                if (res.status !== 200) {
                    dispatch(_1.removeComment(comment.uid));
                }
            })
                .catch(function (e) {
                dispatch(_1.removeComment(comment.uid));
            });
        },
        deleteComment: function (comment) {
            dispatch(_1.removeComment(comment.uid));
            fetch('/comment', {
                method: 'DELETE',
                credentials: 'same-origin',
                body: comment.uid,
                headers: csrf.withCSRFToken({
                    'Content-Type': 'application/json',
                }),
            })
                .then(function (res) {
                if (res.status !== 200) {
                    dispatch(_1.addComment(comment));
                }
            })
                .catch(function (e) {
                dispatch(_1.addComment(comment));
            });
        },
    };
};
var CommentOptions = /** @class */ (function (_super) {
    __extends(CommentOptions, _super);
    function CommentOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.deleteComment = _this.deleteComment.bind(_this);
        return _this;
    }
    CommentOptions.prototype.componentWillMount = function () {
        this.setState({ deleting: false, errorDeleting: false, mounted: false });
    };
    CommentOptions.prototype.deleteComment = function () {
        this.setState({ deleting: true });
        this.props.deleteComment(this.props.comment);
    };
    CommentOptions.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.commentOptions, tabIndex: 0 },
            React.createElement("img", { src: env_1.env().staticSrcPath() + "/assets/images/icons/vertical-dots.svg" }),
            React.createElement("div", { className: styles.commentMenu, tabIndex: 0 }, this.state && this.state.deleting ? (React.createElement("div", null, "Deleting...")) : (React.createElement("div", { onClick: function () { return _this.deleteComment(); } },
                React.createElement("span", null, this.state && this.state.errorDeleting ? 'Delete Error' : 'Delete'),
                React.createElement("img", { src: env_1.env().staticSrcPath() + "/assets/images/icons/close_color.svg" }))))));
    };
    return CommentOptions;
}(React.Component));
exports.CommentOptions = CommentOptions;
var commentJSX = function (_a) {
    var comments = _a.comments, user = _a.user, scene = _a.scene, loginUrl = _a.loginUrl, newComment = _a.newComment, deleteComment = _a.deleteComment;
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.commentCount }, comments.length === 1 ? '1 Comment' : comments.length + ' Comments'),
        React.createElement("div", { className: styles.newComment },
            React.createElement("div", { className: styles.holdProfile }, index_1.ProfileImage(user)),
            React.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    if (!user.handle) {
                        return (window.location.href = loginUrl.loginUrl);
                    }
                    if (e.currentTarget.comment.value.length < 1) {
                        return false;
                    }
                    newComment({
                        scene: scene,
                        user: user.handle,
                        userProfile: user,
                        content: e.currentTarget.comment.value,
                        uid: cuid(),
                    });
                    e.currentTarget.comment.value = '';
                    e.currentTarget.comment.blur();
                    return true;
                } },
                React.createElement("input", { type: 'text', name: 'comment', autoComplete: 'off', placeholder: comments.length === 0 ? 'Get the conversations started!' : 'Join the conversation!' }),
                React.createElement("input", { type: 'submit', className: styles.submit, value: 'Post' }))),
        comments.map(function (comment) {
            return (React.createElement("div", { className: styles.comment, key: comment.uid },
                React.createElement("a", { className: styles.details, href: "/profile/" + comment.userProfile.handle },
                    index_1.ProfileImage(comment.userProfile),
                    React.createElement("div", { className: styles.nameTime },
                        React.createElement("div", { className: styles.name }, comment.userProfile.name),
                        React.createElement("div", { className: styles.date }, moment(comment.date).fromNow()))),
                React.createElement("div", { className: styles.content },
                    user.handle === comment.userProfile.handle ? (React.createElement(CommentOptions, { comment: comment, deleteComment: deleteComment })) : (''),
                    comment.content)));
        })));
};
exports.Comments = react_redux_1.connect(exports.mapStateToProps, exports.mapDispatchToProps)(commentJSX);
